import {
    CatizMonitors, NotsSystem, S80Monitors, SystemMonitors, SystemTabs
} from '../helpers/constants';

class SystemConfig {
  private _system!: NotsSystem;
  private _monitors: SystemMonitors[] = [S80Monitors.LOWER, S80Monitors.UPPER];
  private _currentTab!: SystemTabs;
  public get system() {
    if (!this._system) {
      throw new Error('SystemConfig not initialized');
    }
    return this._system;
  }
  public get monitors() {
    if (!this._system) {
      throw new Error('SystemConfig not initialized');
    }
    return this._monitors;
  }
  public setSystem(system: NotsSystem): SystemConfig {
    this._system = system;
    switch (system) {
      case NotsSystem.S80:
        this._monitors = [S80Monitors.LOWER, S80Monitors.UPPER];
        break;
      case NotsSystem.CATIZ:
        this._monitors = [CatizMonitors.MainMapArea, CatizMonitors.GFCSMapArea];
        break;
      case NotsSystem.HERMSYS:
        this._monitors = [];
        break;
      default:
        console.error('Unknown nots system, critical error');
        alert('Unknown nots system, critical error');
        break;
    }
    return this;
  }
  public setCurrentTab(tab: SystemTabs): SystemConfig {
    this._currentTab = tab;
    return this;
  }
  public get currentTab() {
    return this._currentTab;
  }
}

const System: SystemConfig = new SystemConfig();
export default System;
